import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setRegisterIndex } from "../../../../../store/compoIndex";
import { useSelector } from "react-redux";
import { TabMenuContainer } from "../styled/common";

export default function RegisterMenu({ index }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const naviagte = useNavigate();

  const setting = useSelector((state) => state?.user?.setting);

  const movePage = (idx) => {
    dispatch(setRegisterIndex(idx));

    const { pathname } = location;
    if (pathname !== "/mypage/register") {
      naviagte("/mypage/register");
    }
  };

  return (
    <TabMenuContainer className={setting?.mode}>
      <ul>
        {registerMenu.map((item, i) => (
          <li
            style={{ padding: "0" }}
            className={index === i ? "active" : ""}
            key={i}
            onClick={() => movePage(i)}>
            {item.label}
          </li>
        ))}
      </ul>
    </TabMenuContainer>
  );
}
